import { useState, useEffect } from 'react';
import {
  TextField, Typography,
  TableContainer, Table, TableRow, TableCell, TableHead, TableBody, Link,
  ButtonBase,
} from '@material-ui/core';
import Pagination from '../components/pagination'
import moment from 'moment';
import { API_BASE_URL, BASE_SITE_URL } from '../config/constant';
import { curl_post, getToken } from '../helpers/untils';

const TollSearchListTable = (props) => {
  const { selectedDevice, updateTimestamp, setUpdateTimestamp, items } = props;
  const [currentPage, setCurrentPage] = useState(1);
  const [currentTableData, setCurrentTableData] = useState([]);
  const PageSize = 5;

  useEffect(() => {
    const firstPageIndex = (currentPage - 1) * PageSize;
    const lastPageIndex = firstPageIndex + PageSize;
    setCurrentTableData(items.slice(firstPageIndex, lastPageIndex))
  }, [currentPage, items]);

  const onClickDownload = (uri) => {
    const token = getToken()
    const curTimestamp = moment().format('YYYYMMDD-HHmmss')
    const payload = {
      uri: uri,
      curTimestamp: curTimestamp,
    }
    console.log(`onClickDownload payload:::`, payload)
    const urlExport = API_BASE_URL + "/api/file/download";
    const exportFileName = uri.split('/').pop();
    curl_post(urlExport, { ...payload, exportFileName }, 'post', "", true, token); //window.location.href = exportUrl
  }

  return (
    <>
      <Typography variant="h6" component="h2" style={{ marginBottom: 16 }}>Toll Query List</Typography>

      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Start Date</TableCell>
              <TableCell>End Date</TableCell>
              <TableCell>JPG</TableCell>
              <TableCell>PDF</TableCell>
              <TableCell>HTML</TableCell>
              <TableCell>Payment Method</TableCell>
              <TableCell>Email to</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {
              (currentTableData.length > 0) ? (
                currentTableData.map((item) =>
                  <TableRow key={item.id}>
                    <TableCell>{moment.unix(item.from).format("DD MMM YY")}</TableCell>
                    <TableCell>{moment.unix(item.to).format("DD MMM YY")}</TableCell>
                    <TableCell>
                      {
                        (item.jpg_created) ? (
                          <ButtonBase
                            disableRipple={true}
                            onClick={() => onClickDownload(item.jpg_zip_filename ? `/uploads/tolls/${item.jpg_zip_filename}` : `/uploads/tolls/toll_report_${item.id}.jpg`)}
                          >
                            {`jpg`}
                          </ButtonBase>
                        ) : (
                          <div style={{ textAlign: 'center' }}>-</div>
                        )
                      }
                    </TableCell>
                    <TableCell>
                      <ButtonBase
                        disableRipple={true}
                        onClick={() => onClickDownload(`/uploads/tolls/toll_report_${item.id}.pdf`)}
                      >
                        {`pdf`}
                      </ButtonBase>
                    </TableCell>
                    <TableCell>
                      <Link
                        href={`/toll-list/${item.id}`}
                        target={`_blank`}
                      >
                        {`html`}
                      </Link>
                    </TableCell>
                    <TableCell>{item.paymentMethod}</TableCell>
                    <TableCell>
                      <TextField
                        placeholder="Enter emails with comma separated"
                      />
                    </TableCell>
                  </TableRow>
                )
              ) : (
                <TableRow key={`no-data`}>
                  <TableCell colSpan={7} align="center">No item found</TableCell>
                </TableRow>
              )
            }

          </TableBody>
        </Table>
        <div style={{ marginTop: '5px' }}></div>
        <Pagination
          className="pagination-bar"
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          pageSize={PageSize}
          totalCount={items.length}
          onPageChange={page => setCurrentPage(page)}

        />
      </TableContainer>
    </>
  )
}

export default TollSearchListTable;
